/**
 * Auto-generated prismacide icon component.
 */
import { default as DefaultIcon } from '~icons/prismacide/market-messages';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const MarketMessagesIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
